/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';

import { ApiPollQuestion } from './PollQuestion';
import { ApiGoal } from './Goal';
import { ApiAbbreviatedTalent } from './AbbreviatedTalent';
import { ApiUserSnippet } from './UserSnippet';
import { ApiTopic } from './Topic';
import { ApiPollActivity } from './PollActivity';
import { ApiOfferSet } from './OfferSet';
import { ApiPollPost } from './PollPost';

export interface PollRequest {

    type?: string;

    title?: string;

    description?: string;

    /**
     * File location
     */
    image?: string;

    opens_at?: string;

    closes_at?: string;

    vote_changeable?: boolean;

    membership_required?: boolean;

    hide_results_before_voting?: boolean;

    hide_results_after_voting?: boolean;

    featured_at?: string;

    featured_expires_at?: string;

    topic_id?: string;

    offer_set_id?: number;

    questions?: ApiPollQuestion[];

    goal?: ApiGoal;

    endorsements?: ApiAbbreviatedTalent[];

    id?: string;

    slug?: string;

    status?: string;

    state?: string;

    author?: ApiUserSnippet;

    topic?: ApiTopic;

    recent_activity?: ApiPollActivity[];

    /**
     * Offer set attached to this poll/petition
     */
    offer_set?: ApiOfferSet;

    /**
     * ID of Klaviyo list that will contain all signers of the petition
     */
    klaviyo_list_id?: string;

    /**
     * ID of a Klaviyo campaign created as a template for petition updates
     */
    klaviyo_update_campaign_id?: string;

    posts?: ApiPollPost[];

}

@Model('Poll')
export class ApiPoll extends BaseModel implements PollRequest {

    
    
    type: string;

    
    
    title: string;

    
    
    description: string;

    /**
     * File location
     */
    
    
    image: string;

    
    
    opens_at: string;

    
    
    closes_at: string;

    
    
    vote_changeable: boolean;

    
    
    membership_required: boolean;

    
    
    hide_results_before_voting: boolean;

    
    
    hide_results_after_voting: boolean;

    
    
    featured_at: string;

    
    
    featured_expires_at: string;

    
    
    topic_id: string;

    
    
    offer_set_id: number;

    @Type('ApiPollQuestion')
    @Expand()
    questions: ApiPollQuestion[];

    @Type('ApiGoal')
    @Expand()
    goal: ApiGoal;

    @Type('ApiAbbreviatedTalent')
    @Expand()
    endorsements: ApiAbbreviatedTalent[];

    
    
    id: string;

    
    
    slug: string;

    
    
    status: string;

    
    
    state: string;

    @Type('ApiUserSnippet')
    @Expand()
    author: ApiUserSnippet;

    @Type('ApiTopic')
    @Expand()
    topic: ApiTopic;

    @Type('ApiPollActivity')
    @Expand()
    recent_activity: ApiPollActivity[];

    /**
     * Offer set attached to this poll/petition
     */
    @Type('ApiOfferSet')
    @Expand()
    offer_set: ApiOfferSet;

    /**
     * ID of Klaviyo list that will contain all signers of the petition
     */
    
    
    klaviyo_list_id: string;

    /**
     * ID of a Klaviyo campaign created as a template for petition updates
     */
    
    
    klaviyo_update_campaign_id: string;

    @Type('ApiPollPost')
    @Expand()
    posts: ApiPollPost[];

}
